package net.bothosting.docs.pages.faqs_and_info

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initCan_i_create_a_free_serverPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("faqs_and_info/can_i_create_a_free_server.md", FrontMatterElement.EmptyMap))
}

@Page("/faqs_and_info/can-i-create-a-free-server")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Can_i_create_a_free_serverPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("can-i-create-a-free-server") }) {
        org.jetbrains.compose.web.dom.Text("Can I Create a Free Server?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Yes, you can. bot-hosting.net is a 100% free service with 24/7 uptime.")
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Text("The only thing you need to keep your server running is to claim coins using the ")
        com.varabyte.kobweb.silk.components.navigation.Link("../hosting_in_bot_hosting_net/coin-system_explained.md") {
            org.jetbrains.compose.web.dom.Text("Coin System Explained")
        }
        org.jetbrains.compose.web.dom.Text(" guide so you have enough coins for server renewal.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Here is a step-by-step guide to get started with bot-hosting.net: ")
        com.varabyte.kobweb.silk.components.navigation.Link("/broken/spaces/zlWJKPhyFl109QbriNWb/pages/FNtMzF6Q2dLRvCwC5vLm") {
            org.jetbrains.compose.web.dom.Text("Hosting in Bot-hosting.net")
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Experiencing issues while creating a server as a free user? Check out ")
            com.varabyte.kobweb.silk.components.navigation.Link("issues-creating_server_free_users.md") {
                org.jetbrains.compose.web.dom.Text("Issues Creating Server [Free Users]")
            }
            org.jetbrains.compose.web.dom.Text(".")
        }
    }
}
